import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";
import { camel } from "~/utils/caseUtils";

type SamtykkeType = "MARKEDSFORING" | "DYBDE";

export interface Samtykke<T = void> {
	fromDate: Date;
	id: number;
	leadParagraph: string;
	samtykkeType: T extends SamtykkeType ? T : SamtykkeType;
	text: string;
	title: string;
	toDate: Date;
}

export type SamtykkeState = {
	[K in Lowercase<SamtykkeType>]: Samtykke<Uppercase<K>>;
};

export const defaultState = {} as SamtykkeState;

export default function samtykkeReducer(state = defaultState, action: Action) {
	switch (action.type) {
		case actions.SAMTYKKE_TEXTS_RESPONSE:
			return {
				...state,
				...action.data.reduce((result, item) => ({ ...result, [camel(item.samtykkeType)]: item }), {}),
			} as SamtykkeState;
		default:
			return state;
	}
}
